import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';

import debounce from 'lodash/debounce';

import HeaderTabs from './Components/HeaderTabs';
import CallToActions from './Components/CallToActions';
import BetHistoryLink from './Components/BetHistoryLink';

import BetslipPage from './Pages/Betslip';
import MyBetsPage from './Pages/MyBets';

import {
    selectIsBetslipTab,
    selectIsMyBetsTab,
    selectIsPlacingBet,
} from '~Betslip/selectors/uiSelectors';

import {
    isUserLoggedIn,
} from '~shared/utils/user';

import './styles/full.scss';

const Full = () => {
    const isBetslipTab = useSelector(selectIsBetslipTab);
    const isMyBetsTab = useSelector(selectIsMyBetsTab);
    const isPlacingBet = useSelector(selectIsPlacingBet);

    const getWindowInnerHeight = () => window.innerHeight;

    const [ fullslipViewHeight, setFullslipViewHeight ] = useState(getWindowInnerHeight());

    useEffect(() => {
        window.addEventListener('resize', debouncedSetFullslipViewHeight);

        return () => {
            window.removeEventListener('resize', debouncedSetFullslipViewHeight);
        };
    }, []);

    const debouncedSetFullslipViewHeight = debounce(() => {
        setFullslipViewHeight(getWindowInnerHeight());
    }, 100);

    const inlineStyle = {
        '--fullslip-view-height': `${fullslipViewHeight}px`,
    };

    const fullslipClasses = classNames('fullslip', {
        'fullslip--placing-bet': isPlacingBet,
    });

    return (
        <div className={fullslipClasses} style={inlineStyle}>
            <HeaderTabs />

            {
                isBetslipTab
                ?
                    <>
                        <BetslipPage />
                        <CallToActions />
                    </>
                : null
            }

            {
                isMyBetsTab
                ?
                    <>
                        <MyBetsPage />
                        {
                            isUserLoggedIn()
                            ?
                                <div className="fullslip__bet-history-button-container">
                                    <BetHistoryLink />
                                </div>
                            : null
                        }
                    </>
                : null
            }
        </div>
    );
};

export default Full;
